import InputFiles from 'components/Commun/Form/InputFiles';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Col, Row } from '@design-system-etat/dsfr-react';
import styles from './PhotoIdentite.module.scss';
import DisplayFileFromBack from '../../Image/DisplayFileFromBack';

const PhotoIdentite = ({ titre, photoIdentite }) => {
    const hookForm = useFormContext({
        mode: 'onSubmit',
    });
    const { formState } = hookForm;
    const [fileToDisplay, setFileToDisplay] = useState(null);

    useEffect(() => {
        if (photoIdentite && photoIdentite.uuid) {
            const getImage = async () => {
                const dataImage = await DisplayFileFromBack(photoIdentite.uuid);
                setFileToDisplay(dataImage);
            };

            getImage();
        }

        if (photoIdentite && !photoIdentite.uuid) {
            setFileToDisplay({ contenu: photoIdentite, libelle: "Photo d'identité" });
        }

        if (photoIdentite === null) {
            setFileToDisplay(null);
        }
    }, [photoIdentite]);

    return (
        <>
            {titre && (
                <Row>
                    <Col col={12}>
                        <div className={styles.photoIdentite__titre}>
                            <span className="fr-icon-camera-fill icon-color" aria-hidden="true" />{' '}
                            {titre}
                        </div>
                    </Col>
                </Row>
            )}

            {fileToDisplay === null && <div className={styles.photoIdentite__icone} />}

            {fileToDisplay && (
                <img src={fileToDisplay.contenu} width="100" alt={fileToDisplay.libelle} />
            )}
            <InputFiles
                name="photoIdentite"
                texteAide="La taille maximale autorisée de votre document est 5Mo. Les formats acceptés sont .png, .jpeg, .jpg"
                accept=".png,.jpeg,.jpg"
                label="Ajouter une photo d'identité"
                error={formState.errors ? formState.errors.photoIdentite : null}
                required
            />
        </>
    );
};

PhotoIdentite.propTypes = {
    titre: PropTypes.string,
    photoIdentite: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default PhotoIdentite;
